import getters from './getters'
import actions from './actions'
import mutations from './mutations'

const state = {
    ccloneDetails: {},
    decisionTree: { status: null, image: null },
    list: [],
    type: 'cclone',
    selectedPointLabel: ''
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
